export const zeroPhoneNumber = "+0000000000"; // Move to constants

export const padNum = (num: number | string): string => {
  const cleanNum = typeof num === "string" ? parseInt(num) : num;
  return cleanNum < 10 ? `0${cleanNum}` : String(cleanNum);
};

export const safeNumber = (input?: string | number): number => {
  const num = Number(input);
  return isNaN(num) ? 0 : num;
};

export const toFormattedInteger = (amount?: string | number): string => {
  return parseInt(safeNumber(amount).toString()).toLocaleString("en-US");
};

export const toFormattedFloat = (
  amount?: string | number,
  precision = 1,
): string => {
  return parseFloat(safeNumber(amount).toString()).toLocaleString("en-US", {
    minimumFractionDigits: precision,
    maximumFractionDigits: precision,
  });
};

export const safeIntegerDivision = (
  numerator?: string | number,
  denominator?: string | number,
): string => {
  return toFormattedInteger(safeNumber(numerator) / safeNumber(denominator));
};

export const safeRateToPercent = (rate?: string | number): string => {
  return (safeNumber(rate) * 100).toLocaleString("en-US");
};

export const safePercentToRate = (percent?: string | number): string => {
  return (safeNumber(percent) / 100).toLocaleString("en-US");
};

// careful with this function
export const commaSeparatedNumbersToArray = (numStr?: string): number[] => {
  // Input Format:
  //  1. starts with <number>
  //  2. followed by repeating pattern:
  //    a) <comma> <number>
  //    b) <comma> <space> <number>
  const csvFormat = /^\d+(, ?\d+)*$/;
  return !numStr || !numStr?.match(csvFormat)
    ? []
    : numStr
        .split(",")
        .map(Number)
        .filter((num) => !isNaN(num));
};
